import styled from "styled-components"
import { Flex, FlexProps } from "rebass"
import theme from "../../theme"

const ModalCardBody = styled<FlexProps>(Flex)`
  background: ${theme.colors.modalFooter};
  color: ${theme.colors.modalText};
  -webkit-overflow-scrolling: touch;
  background-color: ${theme.colors.modalFooter};
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  z-index: 2;
`

export default ModalCardBody
